// extracted by mini-css-extract-plugin
module.exports = {"linkContainer":"FormFooterLink_linkContainer__14eu_","link":"FormFooterLink_link__xJ34m","text":"FormFooterLink_text__2yq6S"};